// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"4be262b6","787":"23583d7b"}[chunkId] + ".chunk.js";
};